import { render, staticRenderFns } from "./PracticePrivilegesModal.vue?vue&type=template&id=7908e570&scoped=true"
import script from "./PracticePrivilegesModal.vue?vue&type=script&lang=js"
export * from "./PracticePrivilegesModal.vue?vue&type=script&lang=js"
import style0 from "./PracticePrivilegesModal.vue?vue&type=style&index=0&id=7908e570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7908e570",
  null
  
)

export default component.exports